import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseService } from './loja/base.service';

@Injectable()
export class SysService extends BaseService {

    constructor(protected http: Http) {
        super(http, 'api/v21/admin', 'sys')
    }

    private decodeParams(menu) {
        return menu.map(item => {
            if (item.path) {
                let params = this.params(item.path);
                if (params.length > 0) {
                    for (let param of params) {
                        item.path = item.path.split(`{${param}}`).join(sessionStorage.getItem(param));
                    }
                }
            }
            if (item.children) {
                item.children = this.decodeParams(item.children);
            }
            return item;
        });
    }

    public menu(modules = null) {
        return new Promise<any>((resolve) => {
            let useCache = true;

            let params: any = {
                router: 'menu'
            }

            if (modules) {
                params.query = 'modules=' + modules.join(",");
                useCache = false;
            }

            let cachedMenu = null;//JSON.parse(sessionStorage.getItem('menu'));

            if (!useCache || !cachedMenu || !cachedMenu.data || (cachedMenu.data.length <= 0)) {
                this.getResources(params).subscribe((response) => {
                    response.data = this.decodeParams(response.data);
                    if (useCache) {
                        sessionStorage.setItem('menu', JSON.stringify(response));
                    }
                    resolve(response);
                });
            }
            else {
                resolve(cachedMenu);
            }
        });
    }

    public assets(useCachedMenu = true) {
        return new Promise<any>((resolve) => {
            let cachedMenu = JSON.parse(sessionStorage.getItem('menu-assets'));

            if (!useCachedMenu) {
                sessionStorage.removeItem('menu-assets');
                sessionStorage.removeItem('menu-assets');
                this.getResources({ router: 'menu-assets' }).subscribe((response) => {
                    response.data = this.decodeParams(response.data);
                    resolve(response);
                });
            }
            else if (!cachedMenu || !cachedMenu.data || cachedMenu.data.length <= 0) {
                this.getResources({ router: 'menu-assets' }).subscribe((response) => {
                    response.data = this.decodeParams(response.data);
                    sessionStorage.setItem('menu-assets', JSON.stringify(response));
                    resolve(response);
                });
            }
            else {
                resolve(cachedMenu);
            }
        });
    }

    public params(link: string) {
        let params = [];
        let start = null;
        let end = null;
        for (let i = 0; i < link.length; i++) {
            if (!start) {
                if (link.substring(i, i + 1) == '{') {
                    start = i;
                }
            }
            else if (!end) {
                if (link.substring(i, i + 1) == '}') {
                    end = i;
                }
            }

            if ((start) && (end)) {
                params.push(link.substring(start + 1, end));
                start = null;
                end = null;
            }

        }
        return params;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/sys.service.ts